import { lazy } from "react";

const InvoicePDF = lazy(() => import("../Component/BillingPDF/OnlineServiceBilling/InvoicePDF"));
const InvoicePreview = lazy(() => import("../Component/BillingPDF/OnlineServiceBilling/InvoicePreview"));
const ReceiptPDF = lazy(() => import("../Component/BillingPDF/OnlineServiceBilling/ReceiptPDF"));
const InvoiceDownload = lazy(() => import("../Component/BillingPDF/BusinessBilling/InvoiceDownload"));
const AIAgentInvoicePDF = lazy(() => import("../Component/BillingPDF/AIBilling/AIAgentInvoicePDF"));
const AIAgentReceiptPDF = lazy(() => import("../Component/BillingPDF/AIBilling/AIAgentReceiptPDF"));
const SubscriptionInvoicePDF = lazy(() =>
  import("../Component/BillingPDF/SubscriptionBilling/SubscriptionInvoicePDF")
);
const SubscriptionReceiptPDF = lazy(() =>
  import("../Component/BillingPDF/SubscriptionBilling/SubscriptionReceiptPDF")
);
const MonthEndTaxInvoice = lazy(() =>
  import("../Component/BillingPDF/MonthEndDSATaxInvoice/MonthEndTaxInvoice")
);
const MonthEndInvoiceDataList = lazy(() =>
  import("../Component/BillingPDF/MonthEndDSATaxInvoice/MonthEndInvoiceDataList")
);

const invoiceRoutes = [
  {
    path: "/invoice/:leadId/:packageId/:serviceId",
    element: <InvoicePDF />,
    protected: false,
  },
  {
    path: "/invoice-preview/:leadId/:packageId/:serviceId",
    element: <InvoicePreview />,
    protected: false,
  },
  {
    path: "/receipt-preview/:leadId/:packageId/:serviceId",
    element: <ReceiptPDF />,
    protected: false,
  },
  { path: "/invoice-download/:id/:type", element: <InvoiceDownload />, protected: false },
  { path: "/ai-agent-invoice-preview", element: <AIAgentInvoicePDF />, protected: false },
  { path: "/ai-agent-receipt-preview", element: <AIAgentReceiptPDF />, protected: false },
  {
    path: "/subscription-invoice-preview",
    element: <SubscriptionInvoicePDF />,
    protected: false,
  },
  {
    path: "/subscription-receipt-preview",
    element: <SubscriptionReceiptPDF />,
    protected: false,
  },
  {
    path: "/month-end-tax-invoice-view/:id",
    element: <MonthEndTaxInvoice />,
    protected: false,
  },
  { path: "/month-end-invoice-list", element: <MonthEndInvoiceDataList />, protected: true },
];

export default invoiceRoutes;
